// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__n95iX","containerItemsCenter":"Skeleton_containerItemsCenter__1UcdE"};